import { forwardRef } from 'react';

export type QueryParameterInputProps = {
  fieldName: string;
  urlParamName: string;
};

export const QueryParameterInput = forwardRef<HTMLInputElement, QueryParameterInputProps>(
  (props, ref) => {
    const { fieldName = '', urlParamName = '' } = props;
    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);
    const value = urlParams.get(urlParamName) ?? '';
    return <input ref={ref} type='hidden' name={fieldName} value={value} />;
  }
);
